import { UseQueryResult } from '@tanstack/react-query';

export const isQueryFinishedLoading = (query: UseQueryResult<unknown>) => {
  return query.status === 'success' && query.fetchStatus === 'idle' && !!query.data;
};
